/* eslint-disable no-cond-assign */
export function getOffsetTop(elem: HTMLElement): number {
  let offsetTop = 0;
  do {
    if (!isNaN(elem.offsetTop)) {
      offsetTop += elem.offsetTop;
    }
  } while (elem = elem.offsetParent as HTMLElement);

  return offsetTop;
}
